import { GetCurrentVersion } from './../../model/Response';
import LocalDataService from '@/service/LocalDataService';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store/index';
import ApiEvent from '@/api/ApiEvent';

import { YearlyEventBulkResponseForNursery, YearlyEventResponseForNursery } from 'chaild-api/lib/index';

import dayjs from 'dayjs';
import 'dayjs/locale/ja';
export interface EventState {
  events: YearlyEventResponseForNursery[];
  total: number;
}

@Module({ dynamic: true, store, name: 'event', namespaced: true })
class EventModule extends VuexModule implements EventState {

  public events: YearlyEventResponseForNursery[] = [];
  public total: number = 0;

  public get eventsIncludedDate(): YearlyEventResponseForNursery[] {
  const groupedEvents = this.events.reduce((acc, current) => {
    const index = acc.findIndex((a) => a.date === current.date);
    
    if (index === -1) {
      acc.push({ ...current });
    } else {
      acc[index].eventName += `\n${current.eventName}`;
    }
    
    return acc;
  }, [] as YearlyEventResponseForNursery[]);

  // 日付順（昇順）にソートして返す
  return groupedEvents.sort((a, b) => {
    const aTime = dayjs(a.date);
    const bTime = dayjs(b.date);
    if (aTime.isBefore(bTime)) { return -1; }
    if (aTime.isAfter(bTime)) { return 1; }
    return 0;
  });
}

  @Action({ rawError: true })
  public async fetchEvent(input: { nurseryId: number, from: string, to: string }) {
    try {
      const response: YearlyEventBulkResponseForNursery = await ApiEvent.fetchEvent(input);
      this.setEvent(response.yearlyEvents)
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Mutation
  public setEvent(event: YearlyEventResponseForNursery[]) {
    this.events = event;
  }

}

export const eventModule = getModule(EventModule);
